import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { FikaConcentrateAddressCardStackContentViewModel } from './fika-concentrate-address-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-fika-concentrate-address-card-stack-content',
  templateUrl: './fika-concentrate-address-card-stack-content.component.html',
  styleUrls: ['./fika-concentrate-address-card-stack-content.component.scss'],
  providers: [FikaConcentrateAddressCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FikaConcentrateAddressCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: FikaConcentrateAddressCardStackContentViewModel, // override
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
